import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=4e02aa42"
import script from "./InfoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=4e02aa42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports